module.exports = __webpack_public_path__ + "img/refresh-logo.81fc2f46.svg";